import { render, staticRenderFns } from "./DiaryTitle.vue?vue&type=template&id=2b13c4f6&scoped=true"
import script from "./DiaryTitle.vue?vue&type=script&lang=js"
export * from "./DiaryTitle.vue?vue&type=script&lang=js"
import style0 from "./DiaryTitle.vue?vue&type=style&index=0&id=2b13c4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13c4f6",
  null
  
)

export default component.exports